<template>
  <div class="animated fadeIn dashboard-root row">
    <div class="dashboard-panel col-lg-12 col-xl-12">
      <div>
        <b-row>
          <b-col
            cols="12"
            md="6"
            xl="2"
            lg="2"
            align="center"
            style="padding: 10px; cursor: pointer"
            @click="goToModality(8, false)"
          >
            <b-img :src="ispezionabiliImg" width="200" height="150" rounded />
            <br />
            <span :style="'color: ' + coloreTxt"
              >{{ uniTranslation("TRNSL01") }} <br /><b>{{ uniTranslation("TRNSL03") }}</b></span
            >
          </b-col>

          <b-col
            cols="12"
            md="6"
            xl="2"
            lg="2"
            align="center"
            style="padding: 10px; cursor: pointer"
            @click="goToModality(8, true)"
          >
            <b-img :src="saldobrasateImg" width="200" height="150" rounded />
            <br />
            <span :style="'color: ' + coloreTxt"
              >{{ uniTranslation("TRNSL01") }}<br /><b>{{ uniTranslation("TRNSL02") }}</b></span
            >
          </b-col>
        </b-row>
      </div>
      <!-- <container></container> -->
      <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "Dashboard",
  mixins: [clickaway],
  data() {
    return {
      ispezionabiliImg: "",
      saldobrasateImg: "",
      coloreTxt: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"])
  },
  mounted: function() {
    var that = this;
    that.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
    that.getColoriCardAction();
    that.getColoriBodyAction();
    that.getColoriHeaderAction();
    that.getColoriFooterAction();
    that.getColoriSidebarAction();

    that.getFluidsAction();
    that.getRefrigerantsAction();

    that.getImageModAction("PIASTRE_ISPEZIONABILI.jpg").then(data => {
      that.ispezionabiliImg = data;
    }).catch(() => {
      location.reload();
    });
    that.getImageModAction("PIASTRE_SALDOBRASATE.jpg").then(data => {
      that.saldobrasateImg = data;
    }).catch(() => {
      location.reload();
    });

    that.coloreTxt = "#004f8c !important";

    that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });

    var isDebugMode = window.location.href.includes("localhost:");
    that.debugMode(isDebugMode);
  },
  methods: {
    ...mapActions("_dashboardModule", ["getImageModAction"]),
    ...mapActions("_colorsModule", [
      "getColoriCardAction",
      "getColoriSidebarAction",
      "getColoriBodyAction",
      "getColoriFooterAction",
      "getColoriHeaderAction"
    ]),
    ...mapActions("_fluidModule", ["getFluidsAction", "getRefrigerantsAction"]),
    ...mapActions("_prjModule", ["setTypePiastra", "create", "load", "save"]),
    ...mapActions("_commonModule", ["setLoading", "setDebugMode"]),

    goToModality: function(modality, bool) {
      var that = this;
      that.setTypePiastra(bool).then(() => {
        that.doAction(modality, bool);
        /*
        MARCO DC 06/04/2022
        Visto che la Cordivari ha solo il fluido fluido
        con Andrea abbiamo deciso di farlo partire in selezione
        => tanto possono cambiare la modalità di calcolo in seguito nella maschera di calcolo

        that.$router.push({
          name: "CreateProject",
          params: {
            modality: modality
          }
        });
        
        */
      });
    },
    debugMode(val) {
      this.setDebugMode(val);
    },
    doAction(modality, bool) {
      this.setLoading({ bool: true, icon: "fa-solid fa-clock fa-5x" });
      var that = this;
      that.supportDesign = false;
      var bShowDesign = false;
      var bShowSelection = false;

      bShowDesign = false;
      bShowSelection = true;

      var payload = {};

      /*
        bNewProject = true;
        bShowDesign = false;
        bShowSelection = true;
        */
      payload.modality = modality;
      payload.bShowDesign = bShowDesign;
      payload.bShowSelection = bShowSelection;

      that
        .create(payload)
        .then(function(data) {
          //console.log(bool);
          that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
          data.bottomSelection.saldobrasata = bool;

          var innerPayload = {};
          innerPayload.projectId = data.projectId;
          innerPayload.project = data;
          innerPayload.modality = modality;

          that.load(innerPayload);

          var obj = {};
          obj[data.projectId] = data;

          that.save(obj).then(function(data) {
            that.projectId = data.projectId;

            that.$router
              .push({
                name: "ViewProject",
                params: {
                  modality: modality,
                  projectId: that.projectId
                }
              })
              .catch(() => {});
          });
        })
        .catch(async function(e) {
          const delay = ms => new Promise(res => setTimeout(res, ms));
          await delay(30000);
          that.setLoading({ bool: false, icon: "fa-solid fa-clock fa-5x" });
          that.doAction(modality, bool);
        })
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/custom";

$application-box-width: 300px;
$application-box-height: 100%;

$application-image-size: 80px;
$modality-logo-size: 40px;

$selected-opacity: 0.5;

.modality-logo-placeholder {
  border-radius: 3px;
  width: $modality-logo-size;
  height: $modality-logo-size;
}

.modality_1 {
  .modality-logo-placeholder {
    background-color: red;
  }
}

.modality_2 {
  .modality-logo-placeholder {
    background-color: blue;
  }
}

.modality_3 {
  .modality-logo-placeholder {
    background-color: #ab5aa7;
  }
}

.modality_4 {
  .modality-logo-placeholder {
    background-color: #5aab8c;
  }
}

.modality_5 {
  .modality-logo-placeholder {
    background-color: gold;
  }
}

.modality_6 {
  .modality-logo-placeholder {
    background-color: green;
  }
}

.modality_7 {
  .modality-logo-placeholder {
    background-color: yellow;
  }
}

.modality_8 {
  .modality-logo-placeholder {
    background-color: red;
  }
}

.modality_9 {
  .modality-logo-placeholder {
    background-color: blue;
  }
}

.modality_10 {
  .modality-logo-placeholder {
    background-color: #ab5aa7;
  }
}

.modality_11 {
  .modality-logo-placeholder {
    background-color: #5aab8c;
  }
}

.applications-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .application-item {
    position: relative;
    width: $application-box-width;
    height: $application-box-height;
    display: flex;
    justify-content: center;
    align-items: center;

    .application-card {
      display: flex;
      justify-content: flex-start;
      width: 100%;

      margin: 5px;
      padding: 20px;
      border-radius: 6px;

      background-color: $unilab-secondary;
      cursor: pointer;

      img {
        border-radius: 4px;
        width: $application-image-size;
        height: $application-image-size;
      }

      span {
        margin-left: 10px;
        font-size: 1.2em;
        // text-transform: uppercase;
      }
    }

    &.selected {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      background-color: $selection-active-opacity;
    }
  }

  .modalities-row {
    width: auto;
    position: absolute;
    top: $application-box-height;
    z-index: 100;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding-bottom: 5px;

    background-color: $selection-active-opacity;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;

    .modality-item {
      width: 100%;

      .modality-card {
        display: flex;
        align-items: center;

        margin: 5px 10px;
        background-color: aliceblue;
        padding: 10px;
        border-radius: 6px;

        cursor: pointer;

        span {
          padding-left: 10px;
        }

        .modality-logo-placeholder {
          border-radius: 3px;
          width: $modality-logo-size;
          height: $modality-logo-size;
        }
      }
    }
  }
}

/*.news-panel {

}*/
</style>
